import React from 'react';

const enterKeyCode = 13;

interface Props {
  children: React.ReactNode;
  onActivate: Function;
  renderTag?: React.ElementType;

  [index: string]: any;
}

/**
 * Enter in a text box inside the element is the box's - the rename form in
 * a playlist row submits on it - and not a second activation of the row.
 */
export function isEnterForTheRow(ev: React.KeyboardEvent) {
  if (ev.keyCode !== enterKeyCode) {
    return false;
  }

  const tag = (ev.target as HTMLElement).tagName;

  return tag !== 'INPUT' && tag !== 'TEXTAREA' && tag !== 'SELECT';
}

export default React.forwardRef<HTMLElement, Props>(function AccessibleElement(
  { children, onActivate, renderTag, ...rest },
  ref,
) {
  return React.createElement(
    renderTag || 'div',
    {
      ref,
      tabIndex: 0,
      onClick: onActivate,
      onKeyDown: (ev: React.KeyboardEvent) => isEnterForTheRow(ev) && onActivate(),
      ...rest,
    },
    children,
  );
});
